const categoriesStrings = {
  priceLists: {
    emptyState: 'There are no price lists',
    createAPriceList: 'Create price list',
    priceList: 'Price list name',
    priceListPlaceholder: 'Price list name',
    createPriceList: 'Create Price List',
    editPriceList: 'Edit Price List',
    cancel: 'Cancel',
    showMore: 'Show More',
  },
  doctorConsultationPriceLists: {
    consultationFee: 'Consultation Fee',
  },
  doctorConsultationPriceListsTable: {
    emptyStateText: 'There are no matches for your search',
    emptyStateSubText: 'Try searching with another name',
    gridHeaderList: {
      priceList: 'Price List',
      consultationFee: 'Consultation Fee',
      status: 'Status',
    },
  },
  labsPriceListsTable: {
    emptyStateText: 'There are no matches for your search',
    emptyStateSubText: 'Try searching with another name',
    gridHeaderList: {
      priceList: 'Price List',
      status: 'Status',
    },
  },
  scansPriceListsTable: {
    emptyStateText: 'There are no matches for your search',
    emptyStateSubText: 'Try searching with another name',
    gridHeaderList: {
      priceList: 'Price List',
      status: 'Status',
    },
  },
  clinicServicesPriceListsTable: {
    emptyStateText: 'There are no matches for your search',
    emptyStateSubText: 'Try searching with another name',
    gridHeaderList: {
      priceList: 'Price List',
      status: 'Status',
    },
  },
  doctorConsultationProviders: {
    emptyState: 'There are no doctors',
    addDoctor: 'Add doctor',
  },
  labsProviders: {
    emptyState: 'There are no labs',
    addProvider: 'Add lab',
  },
  clinicServicesProviders: {
    emptyState: 'There are no Providers',
    addProvider: 'Add Providers',
  },
  surgicalProviders: {
    emptyState: 'There are no Surgical Providers',
    addProvider: 'Add Surgical Providers',
  },
  scansProviders: {
    emptyState: 'There are no scans',
    addProvider: 'Add scan',
  },
  providerDiscounts: {
    emptyState: 'There are no providers',
    addProvider: 'Add provider',
    gridHeaderList: {
      priceList: 'Entity',
      key: 'key',
    },
  },
  doctorConsultationProvidersTable: {
    emptyStateText: 'There are no matches for your search',
    emptyStateSubText: 'Try searching with another name',
    gridHeaderList: {
      priceList: 'Doctor',
      key: 'key',
      component: 'Is Exclusive',
      status: 'Status',
    },
    spokeLabel: 'Spoke',
  },
  labsProvidersTable: {
    emptyStateText: 'There are no matches for your search',
    emptyStateSubText: 'Try searching with another name',
    gridHeaderList: {
      priceList: 'Labs',
      status: 'Status',
    },
  },
  clinicServicesProvidersTable: {
    emptyStateText: 'There are no matches for your search',
    emptyStateSubText: 'Try searching with another name',
    gridHeaderList: {
      priceList: 'InClinic Services',
      key: 'key',
      status: 'Status',
      component: 'Is Exclusive',
    },
  },
  surgicalProvidersTable: {
    emptyStateText: 'There are no matches for your search',
    emptyStateSubText: 'Try searching with another name',
    gridHeaderList: {
      priceList: 'Surgical Providers',
      status: 'Status',
      component: 'Is Exclusive',
    },
  },
  scansProvidersTable: {
    emptyStateText: 'There are no matches for your search',
    emptyStateSubText: 'Try searching with another name',
    gridHeaderList: {
      priceList: 'Labs',
      status: 'Status',
    },
  },
  addScansModal: {
    title: 'Add scan provider',
    searchBarPlaceHolder: 'Search for a scan provider',
  },
  addLabsModal: {
    title: 'Add labs',
    searchBarPlaceHolder: 'Search for a lab',
  },
  addSurgicalProvidersModal: {
    title: 'Add Surgical Providers',
    searchBarPlaceHolder: 'Search for a Surgical Providers',
  },
  clinicServicesModal: {
    title: 'Add InClinic Services',
    searchBarPlaceHolder: 'Search for an InClinic Service',
  },
  addServicesModal: {
    title: 'Add Services',
    searchBarPlaceHolder: 'Search for a service',
  },
  filters: {
    areaFilterPlaceholder: 'Area',
    specialityFilterPlaceholder: 'Speciality',
    emptyAreaFilter: 'No Areas',
    emptySpecialityFilter: 'No Specialities',
  },
  pharmaciesPriceListsTable: {
    emptyStateText: 'There are no matches for your search',
    emptyStateSubText: 'Try searching with another name',
    gridHeaderList: {
      priceList: 'Price List',
      consultationFee: 'Discounts',
      status: 'Status',
    },
  },
  pharmaciesProviders: {
    emptyState: 'There are no pharmacies',
    addPharmacy: 'Add Pharmacy',
  },
  pharmaciesProvidersTable: {
    emptyStateText: 'There are no matches for your search',
    emptyStateSubText: 'Try searching with another name',
    gridHeaderList: {
      provider: 'Pharmacy',
      status: 'Status',
    },
  },
  medicalServices: {
    emptyState: 'There are no services',
    addServices: 'Add Services',
  },
  medicalServicesTable: {
    emptyStateText: 'There are no matches for your search',
    emptyStateSubText: 'Try searching with another name',
    gridHeaderList: {
      service: 'Service',
      price: 'Price',
    },
  },
};

export default categoriesStrings;
